import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

function EliminarTipoEstado({
  registro = {}, // { id, nombre }
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    setError("");
    setLoading(true);

    try {
      const id = registro.id;
      if (!id) throw new Error("Id del Tipo de Estado no encontrado.");

      const url = apiRoutes.estadoTipo.deleteUrl(id);

      // DELETE REAL
      await appFetchJson(url, { method: "DELETE" });

      // Avisar al padre
      onDeleted(registro);
      onClose();
    } catch (e) {
      console.error("Error al eliminar tipo de estado:", e);

      let msg = "No fue posible eliminar el Tipo de Estado.";

      if (e.status === 409) {
        msg =
          e.bodyText ||
          e.message ||
          "No se puede eliminar porque está siendo utilizado por otros estados.";
      } else if (e.status === 404) {
        msg = "El Tipo de Estado no existe o ya fue eliminado.";
      } else if (typeof e.message === "string") {
        msg = e.message;
      }

      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      {/* HEADER */}
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Tipo de Estado</h2>
      </div>

      {/* BODY */}
      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm" style={{ color: "#1e72c0ff" }}>
          ¿Está seguro que desea eliminar este Tipo de Estado?
        </div>

        {/* PANEL DE DATOS */}
        <div className="mb-2 bg-gray-50 px-6 py-6">
          <div className="text-center space-y-3">
            <div>
              <span className="text-gray-500 mr-1">Nombre:</span>
              <span className="font-medium">{registro.nombre || "—"}</span>
            </div>
          </div>
        </div>

        {/* ERROR */}
      </div>

      {/* FOOTER */}
      <div className="px-6 py-4 border-t flex items-center gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>

        <button className="btn-fil" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
}

export default EliminarTipoEstado;
